"use strict";
exports.__esModule = true;
var angular = require("angular");
var program_overview_logic_1 = require("./program-overview.logic");
var basic_chart_component_1 = require("../basic-component/basic-chart.component");
var COMPONENT_NAME = 'smartorg.r6.acts.programOverview';
var ProgramOverviewComponent = /** @class */ (function () {
    function ProgramOverviewComponent($scope, $timeout) {
        var _this = this;
        this.$timeout = $timeout;
        $scope.$on('command:BASIC_TABLE', function (event, args) {
            var actionMenuItem = args.actionMenuItem, _a = args.node, _id = _a._id, name = _a.name, menuID = args.menuID, username = args.username, config = args.config, reportOptions = args.reportOptions, excludeFilters = args.excludeFilters;
            _this.title = actionMenuItem || 'Program Overview';
            _this.nodeName = name;
            _this.nodeID = _id;
            _this.menuID = menuID;
            _this.username = username;
            _this.isHigherLevel = isNaN(name.substring(0, 8));
            _this.showTable = false;
            _this.reportOptions = reportOptions;
            _this.excludeFilters = excludeFilters;
            var programOverviewData = config.data.data;
            if (!_this.isHigherLevel) {
                _this.poRecord = { report: programOverviewData };
                _this.process(programOverviewData[0], true);
                _this.menu = _this.getMenu();
            }
            else {
                if (!programOverviewData || (programOverviewData && 'status' in programOverviewData &&
                    (programOverviewData['status'] == 'Done' || programOverviewData['status'] == 'Failed'))) {
                    _this.showGenerateButton = true;
                }
                if (programOverviewData &&
                    programOverviewData['status'] == 'In Progress') {
                    // Shows 'Generate Program Overview' button
                    // when the status is 'In Progress' for more than 3 min.
                    _this.threeMinCheck(programOverviewData);
                }
                _this.poRecord = programOverviewData;
                _this.menu = null;
                if (_this.poRecord) {
                    _this.showTable = true;
                    if (_this.poRecord.status == 'Done') {
                        _this.menu = _this.getMenu();
                    }
                }
            }
        });
        this.showAlert = function (type, title, message) {
            $scope.$emit('workbench:alert', { type: type, title: title, message: message });
        };
    }
    ProgramOverviewComponent.prototype.threeMinCheck = function (programOverviewData) {
        var initiatedOn = Date.parse(programOverviewData['initiatedOn']);
        var ctrl = this;
        this.smartorg.getServerDateTime().then(function (ret) {
            var now = Date.parse(ret);
            var diff = now - initiatedOn;
            ctrl.$timeout(function () {
                ctrl.showGenerateButton = diff > 180000;
            });
        })["catch"](function (err) {
            ctrl.showAlert('danger', 'Error!', err);
        });
    };
    ProgramOverviewComponent.prototype.initRecord = function () {
        return {
            status: 'In Progress',
            initiatedOn: basic_chart_component_1.getDate(),
            username: this.username,
            report: null
        };
    };
    ProgramOverviewComponent.prototype.getMenu = function () {
        var ctrl = this;
        return [{
                'name': 'Export',
                'items': [{
                        'name': 'Tables',
                        'callback': function () {
                            ctrl.exportTables();
                        }
                    }, {
                        'name': 'Tables EU',
                        'callback': function () {
                            ctrl.exportEUTables();
                        }
                    }]
            }];
    };
    ProgramOverviewComponent.prototype.generateReport = function () {
        var _this = this;
        this.showTable = true;
        this.menu = null;
        this.poRecord = this.initRecord();
        this.showGenerateButton = false;
        // const packedReportOptions = btoa(JSON.stringify(this.reportOptions));
        var ctrl = this;
        var packedExcludeFilter = btoa(JSON.stringify(this.excludeFilters));
        this.smartorg.generateProgramOverviewReport(this.nodeID, this.menuID, this.reportOptions, packedExcludeFilter, null).then(function (ret) {
            _this.showGenerateButton = true;
            ctrl.$timeout(function () {
                if (ret && 'data' in ret) {
                    ctrl.poRecord = ret['data'];
                }
                ctrl.menu = ctrl.getMenu();
            });
        })["catch"](function (err) {
            _this.showGenerateButton = true;
            ctrl.showAlert('danger', 'Error!', err);
        });
        ctrl.$timeout(function () {
            _this.showGenerateButton = true;
        }, 180000);
    };
    ProgramOverviewComponent.prototype.exportTables = function () {
        var csv = this.generateCsv(this.poRecord.report);
        Common.downloadCSV(csv, this.title + " - " + this.nodeName);
    };
    ProgramOverviewComponent.prototype.exportEUTables = function () {
        var csv = this.generateCsv(this.poRecord.report, 'EU');
        Common.downloadCSV(csv, this.title + " -(EU)- " + this.nodeName);
    };
    ProgramOverviewComponent.prototype.process = function (programOverviewData, makeGridOptions) {
        if (makeGridOptions === void 0) { makeGridOptions = false; }
        var programOverviewDataPreparer = new program_overview_logic_1.ProgramOverviewDataPreparer(programOverviewData);
        this.firstTableData = programOverviewDataPreparer.makeFirstTableData();
        var secondTableData = programOverviewDataPreparer.makeSecondTableData();
        this.roundedSecondTableData = programOverviewDataPreparer.roundTableData(secondTableData, 'second', 2);
        if (makeGridOptions) {
            var gridOptions = programOverviewDataPreparer.makeThirdTableData();
            var thirdTableData = programOverviewDataPreparer.roundTableData(gridOptions.data, 'third', 3);
            this.roundedGridOptions = {
                columnDefs: gridOptions.columnDefs,
                data: thirdTableData
            };
        }
    };
    ProgramOverviewComponent.prototype.generateCsv = function (programOverviewDataList, format) {
        if (format === void 0) { format = 'US'; }
        var csvs = programOverviewDataList.map(function (data) { return new program_overview_logic_1.ProgramOverviewDataPreparer(data).getCsv(format); });
        return csvs.join('\n\n');
    };
    return ProgramOverviewComponent;
}());
angular.module(COMPONENT_NAME, []).component('programOverview', {
    template: require('./program-overview.component.html'),
    controller: ProgramOverviewComponent,
    bindings: {
        menu: '=',
        smartorg: '=?'
    }
});
exports["default"] = COMPONENT_NAME;
//# sourceMappingURL=program-overview.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/program-overview/program-overview.component.js